import { useQuery } from "@tanstack/react-query"
import * as learnPracticeService from "../services/learnPractice.service"

export function useTrustedRitualists(limit: number = 5) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["trusted-ritualists", limit],
    queryFn: () => learnPracticeService.getHighlightedRitualists(limit),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })

  return {
    ritualists: data ?? [],
    isLoading,
    error,
  }
}
